<template>
  <v-layout row justify-center v-if="question.question_data.modal">
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="headline" v-html="question.question_data.modal.title"></v-card-title>
        <v-card-text v-html="question.question_data.modal.text"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
/* global _ */
import EventBus from '@/buses/EventBus';
export default {
  name: 'question-modal',
  props: [
    'interactionKey',
    'interactionState'
  ],
  data() {
    return {
      loaded: false,
      dialog: false
    }
  },
  computed: {
    interaction() {
      return this.interactionState.interaction;
    },
    question() {
      return this.interactionState.interaction.question;
    },
    options() {
      return this.interactionState.options;
    }
  },
  methods: {

  },
  mounted() {
    EventBus.$on('openModal', () => {
      this.dialog = true;
    });
  }
};
</script>

<style>

</style>
